import { useSurveysBySubject } from './useSurveys';

/**
 * Hook for fetching ACTIVE surveys for DataManagementTab
 * Filters surveys client-side by ACTIVE status
 *
 * @param subjectId - Subject ID for scoping surveys
 * @returns Filtered survey data for ACTIVE status
 */
export const useActiveSurveysForDataManagement = (subjectId: string) => {
  const query = useSurveysBySubject(subjectId);

  // Filter for ACTIVE status surveys
  // Note: query.data is ApiResponse<SurveyDTO[]>, so query.data.data is the array
  // This matches the pattern used in useSurveysForDataManagement
  const activeSurveys = query.data?.data?.filter((survey) => survey.status === 'ACTIVE') || [];

  return {
    ...query,
    data: activeSurveys,
  };
};
